import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Course } from '@/shared/types/course';

export type CoursesTab = 'owned' | 'shared' | 'team';

interface CoursesState {
  selectedCourse: Course | null;
  viewMode: 'grid' | 'list' | 'table';
  currentTab: CoursesTab;
  searchQuery: string;
  sortBy: 'title' | 'updated_at' | 'created_at';
  sortOrder: 'asc' | 'desc';
}

const initialState: CoursesState = {
  selectedCourse: null,
  viewMode: 'table',
  currentTab: 'owned',
  searchQuery: '',
  sortBy: 'updated_at',
  sortOrder: 'desc',
};

const coursesSlice = createSlice({
  name: 'courses',
  initialState,
  reducers: {
    setSelectedCourse: (state, action: PayloadAction<Course | null>) => {
      state.selectedCourse = action.payload;
    },
    setViewMode: (state, action: PayloadAction<'grid' | 'list' | 'table'>) => {
      state.viewMode = action.payload;
    },
    setCurrentTab: (state, action: PayloadAction<CoursesTab>) => {
      state.currentTab = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setSortBy: (state, action: PayloadAction<'title' | 'updated_at' | 'created_at'>) => {
      state.sortBy = action.payload;
    },
    setSortOrder: (state, action: PayloadAction<'asc' | 'desc'>) => {
      state.sortOrder = action.payload;
    },
  },
});

export const {
  setSelectedCourse,
  setViewMode,
  setCurrentTab,
  setSearchQuery,
  setSortBy,
  setSortOrder,
} = coursesSlice.actions;

export default coursesSlice.reducer;
